import { render, staticRenderFns } from "./CheckoutInvestment.html?vue&type=template&id=0ae8a972&"
import script from "./CheckoutInvestment.ts?vue&type=script&lang=ts&"
export * from "./CheckoutInvestment.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/checkout/_investment.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports